import React, { useEffect } from 'react'
import LoginCard from '../components/login/Login'
import '../assets/styles/components/_login.scss'
import { useNavigate } from 'react-router-dom'

const Login = () => {

  const navigate = useNavigate()
  useEffect(() => {
    document.title = "Bienvenidos al PGI | Panel de Gestión Interna Tensolite";
    const logueado = JSON.parse(localStorage.getItem('Usuario'))
    
    if (logueado) {
      navigate("/pgi")
    }
              // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  

  return (
    <div className="login__page">
      <div className='container'>
      <LoginCard />
      </div>
      {/* <SignUpCard /> */}
    </div>
  )
}

export default Login
